import Menu from '../Menu/Menu';
import Header from '../Header/Header';
import { menuDataShape } from '../../shapes/layoutShape';
import PropTypes from 'prop-types';

var Footer = require('./footer');
var Shortcut = require('./shortcut');

var ModuleStore = require('../../store/moduleStore');
var MenuStore = require('../../store/menuStore');
var AccountStore = require('../../store/accountStore');

var BaseModule = React.createClass({
  propTypes: {
    headerData: PropTypes.object,
    title: PropTypes.string,
    menuData: PropTypes.shape(menuDataShape),
    headerChildren: PropTypes.arrayOf(React.PropTypes.element)
  },

  getInitialState: function () {
    return {
      menuItems: MenuStore.getAllItems(),
      currentAccount: null
    }
  },

  componentWillMount: function () {
    MenuStore.addChangeListener(this._onMenuChange);
    AccountStore.addChangeListener(this._onAccountChange);
    this._onAccountChange();
  },

  componentWillUnmount: function () {
    MenuStore.removeChangeListener(this._onMenuChange);
    AccountStore.removeChangeListener(this._onAccountChange);
  },

  _onMenuChange: function () {
    this.setState({
      menuItems: MenuStore.getAllItems()
    });
  },

  _onAccountChange: function () {
    this.setState({
      currentAccount: AccountStore.getAccount()
    });
  },

  render: function () {
    return (
      <div>
        <Header
          headerData={this.props.headerData}
          currentAccount={this.state.currentAccount}
          title={this.props.title}>
          {this.props.headerChildren}
        </Header>
        <div className="base-content-area">
          <Menu menuData={this.props.menuData}
                menuItems={this.state.menuItems}/>
          {this.props.children}
        </div>
        <Footer />
        <Shortcut moduleList={ModuleStore.getModuleList()}
                  currentModule={ModuleStore.getCurrentModule()}/>
      </div>
    );
  }
});

module.exports = BaseModule;
